import React, { useState } from "react";
import { GridCloseIcon } from "@mui/x-data-grid";
import Box from "components/common/Box";
import Drawer from "components/common/Drawer";
import IconButton from "components/common/IconButton";
import Text from "components/common/Text";
import FilterButton from "components/CommonDrawerFilter/FilterButton";
import Filter from "components/CommonDrawerFilter/Filter";

const FilterVehicle = ({
  drawerOpen,
  filters,
  applyFilter,
  filtermanufacture,
  filtermanufactureType,
  filtermodels,
  filtervariants,
  handleFiltertoggleDrawerClose,
}) => {
  const [filterData, setFilterData] = useState([]);
  const [filterbrands, setFilterBrands] = useState([]);
  const [evtype, setEvType] = useState([]);
  const [model, setModel] = useState([]);
  const [variant, setVariant] = useState([]);
  const [usages, setUsages] = useState([]);
  const [iam, setIam] = useState([]);
  const [clearfilter, setClearFilter] = useState(0);
  const handleClear = () => {
    const newFilterData = {
      manufacturer: [],
      manufacturer_type: [],
      variant_name: [],
      model_name: [],
      usages: [],
      i_am: [],
    };
    setFilterData([]);
    applyFilter(newFilterData);
    setClearFilter(clearfilter + 1);
    handleFiltertoggleDrawerClose();
  };

  const handleApply = () => {
    const newFilterData = {
      manufacturer: filterbrands?.selectedBrands,
      manufacturer_type: evtype?.selectedBrands,
      variant_name: variant?.selectedBrands,
      model_name: model?.selectedBrands,
      usages: usages?.selectedBrands,
      i_am: iam?.selectedBrands,
    };

    setFilterData(newFilterData);
    applyFilter(newFilterData);
    handleFiltertoggleDrawerClose();
  };

  return (
    <Drawer
      anchor="right"
      open={drawerOpen}
      onClose={handleFiltertoggleDrawerClose}
    >
      <Box sx={{ width: 250 }} role="presentation">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 1,
          }}
        >
          <Text variant="h6">Filter</Text>
          <IconButton
            aria-label="close"
            onClick={handleFiltertoggleDrawerClose}
            sx={{
              color: (theme) => theme.palette.grey[400],
            }}
          >
            <GridCloseIcon />
          </IconButton>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "2px",
          marginBottom: "24%",
        }}
      >
        {filters?.manufacturer_types && (
          <Filter
            filterData={filterData}
            data={filtermanufactureType}
            filterType="EV Type"
            //   searchkey={true}
            setFilterData={setEvType}
            clearfilter={clearfilter}
            dataType="manufacturer_type"
          />
        )}

        {filters?.manufacturers && (
          <Filter
            data={filtermanufacture}
            filterData={filterData}
            filterType="Brand"
            searchkey={true}
            setFilterData={setFilterBrands}
            clearfilter={clearfilter}
            dataType="manufacturer"
          />
        )}

        {filters?.models && (
          <Filter
            filterData={filterData}
            data={filtermodels}
            filterType="Model"
            searchkey={true}
            setFilterData={setModel}
            clearfilter={clearfilter}
            dataType="model_name"
          />
        )}
        {filters?.variants && (
          <Filter
            filterData={filterData}
            data={filtervariants}
            filterType="Variants"
            searchkey={true}
            setFilterData={setVariant}
            clearfilter={clearfilter}
            dataType="variant_name"
          />
        )}
        {filters?.usage && (
          <Filter
            filterData={filterData}
            data={filters?.usage}
            filterType="Usage"
            searchkey={true}
            setFilterData={setUsages}
            clearfilter={clearfilter}
            dataType="usages"
          />
        )}
        {filters?.i_am && (
          <Filter
            filterData={filterData}
            data={filters?.i_am}
            filterType="I am  a"
            setFilterData={setIam}
            clearfilter={clearfilter}
            dataType="i_am"
          />
        )}
        <Box>
          <FilterButton
            drawerOpen={drawerOpen}
            handleClear={handleClear}
            handleApply={handleApply}
          />
        </Box>
      </Box>
    </Drawer>
  );
};

export default FilterVehicle;
